import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../../Formik'
import { RadioGroup } from '../../../../Radio'
import { VIEWING_FORM_FIELD_NAME } from '../../RentalPortalViewingFormModal.constants'
import { getViewingFormTimeSourceOptions } from '../../RentalPortalViewingFormModal.utils'
import { useViewingFormChangeFields } from '../RentalPortalViewingFormModalFields.hooks'

import * as styles from './ViewingFormTimeSourceField.module.css'

function ViewingFormTimeSourceField() {
  const { t } = useTranslation()

  const { handleChangeTimeSource } = useViewingFormChangeFields()

  return (
    <FormikField
      Component={RadioGroup}
      className={styles.ViewingFormTimeSourceField}
      name={VIEWING_FORM_FIELD_NAME.timeSource}
      options={getViewingFormTimeSourceOptions(t)}
      onChange={handleChangeTimeSource}
    />
  )
}

export default ViewingFormTimeSourceField
